import client from "./client";
import { useNavigate } from "react-router-dom";

export const DOMAIN = 'http://localhost:3000';

export const X_PADDING = "px-4 xs:px-[8%] sm:px-[13%] md:px-[5%] xl:px-[13%]";

export const formatDate = (value) => {
    const d = value instanceof Date ? value : new Date(value);

    return isNaN(d.getTime())
        ? ""
        : d.toISOString().split("T")[0];
};

export const saveNewsItem = async (formRef) => {
    if (!formRef.current?.getData) {
        return false;
    }

    const { sendFormData,errorMessage } = client;

    const data = formRef.current.getData();

    const formData = new FormData();

    // Nested GlobalObjectReference
    if (data.ref) {
        if (data.ref.id != null) {
            formData.append("ref.id", data.ref.id);
        }

        if (data.ref.type) {
            formData.append("ref.type", data.ref.type);
        }

        if (data.ref.service) {
            formData.append("ref.service", data.ref.service);
        }

        if (data.ref.server) {
            formData.append("ref.server", data.ref.server);
        }
    }

    // Other fields
    formData.append("name", data.name ?? "");
    formData.append("description", data.description ?? "");
    formData.append("tag", data.tag ?? "");

    if (data.file) {
        formData.append("file", data.file);
    }

    formData.append(
        "date",
        data.date
            ? data.date.toISOString()
            : new Date().toISOString()
    );

    try {
        await sendFormData("POST", "newsitems", formData);
        return {message:'Successful', success:true}
    } catch (error) {
        console.error(error);
        return {message:errorMessage(error)};
    }
};

export const useNewsNavigation = () => {
    const navigate = useNavigate();

    const newsItemReadMore = (newsItem) => {
        if (!newsItem) return;
        navigate(`/news?itemId=${newsItem.ref.id}`);
    };

    return { newsItemReadMore };
};





